// extracted by mini-css-extract-plugin
export var growableInput = "_6f-0";
export var tagContainer = "_6f-2";
export var textInput = "_6f-1";